export default __webpack_public_path__ + "static/qualityr-bddae27e073f42763a7b0daefc00d088.jpg";